define('v3/Common/Helpers/Sort/Sort.Helper',[
	'knockout',
	'jquery',
	'lodash',
	'v3/Common/Models/enums',
	'v3/Common/Services/pupilSortService',
	'env'
], function (ko, $, _, commonEnums, pupilSortService, env) {
	var log = _.noop; // replace with console.log for debugging
	var classId = env.userInfo.classId;

	function SortableHelper (key, direction, observableArray, columns) {
		var self = this;
		var active;

		this.key = key || ko.observable();
		this.direction = direction || ko.observable();
		this.primary = ko.observable(0);

		if (!this.direction() || !this.key()) {
			active = _.filter(columns, { active: true });
			if (active) {
				this.key(_.head(_.map(active, function (d) {
					return _.map(d.sorting, 'key');
				})) || []);

				this.direction(_.compact(_.head(_.map(active, function (d) {
					return _.map(d.sorting, 'direction');
				}))));
			}

			if (!this.direction().length) {
				this.direction([commonEnums.sortDirection.ascending]);
			}
		}

		var primary = _.find(columns, { sorting: [{ primary: true }] });
		if (primary) {
			_.each(primary.sorting, function (d, k) {
				if (d.primary) {
					self.primary(k);
				}
			});
		}

		var computed = ko.computed(function () {
			if (!ko.isObservable(observableArray)) {
				return [];
			}
			if (_.isNil(observableArray()) || observableArray().length === 0) {
				return [];
			}

			if (self.key()) {
				var keys = self.key();
				var directions = self.direction();
				var newKeys = [];

				if (_.isArray(keys)) {
					_.each(keys, function (key) {
						newKeys.push(self[(self[key]) ? key : 'default'].bind({ scope: self, key: key }));
					});
				} else {
					newKeys.push(self[(self[keys]) ? keys : 'default'].bind({ scope: self, key: keys }));
				}

				log(newKeys, directions);
				return _.orderBy(observableArray(), newKeys, directions);
			} else {
				return observableArray();
			}
		}).extend({ deferred: true });

		computed.key = this.key;
		computed.direction = this.direction;
		computed.primary = this.primary;

		computed.sortBy = function (data) {
			var newDirection, newKey;

			if (data && data.sorting) {
				newKey = _.compact(_.map(data.sorting, 'key'));
				newDirection = _.compact(_.map(data.sorting, 'direction'));

				if (newDirection.length === 0) {
					newDirection.push(commonEnums.sortDirection.ascending);
				}
				if (newKey.length === 0) {
					console.error('SortHelper: sortable "key" was not defined within the column object.');
					return;
				}

				if (_.isEqual(computed.key(), newKey)) {
					// swap directions
					newDirection = (!_.isArray(computed.direction())) ? [computed.direction()] : computed.direction();

					computed.direction(_.map(newDirection, function (dir) {
						return (dir === commonEnums.sortDirection.ascending)
							? commonEnums.sortDirection.descending
							: commonEnums.sortDirection.ascending;
					}));

					log('changed direction', computed.direction());
				} else {
					// change key & direction
					computed.key(newKey);
					computed.direction(newDirection);

					log('changed key', computed.key());
					log('changed direction', computed.direction());
				}
			}
		};

		computed.isActiveKey = function (data) {
			return _.isEqual(self.key(), _.map(data, function (d) {
				return d.key;
			}));
		};

		return computed;
	}

	$.extend(SortableHelper.prototype, {

		default: function (data) {
			var check = ko.unwrap(data[this.key]);

			if (_.isString(check)) {
				check = check.toLowerCase();
			}
			if (_.isBoolean(check)) {
				check = (check) ? 1 : 0;
			}

			return check;
		},

		learningObjectiveState: function (data) {
			switch (data.state()) {
			case commonEnums.learningObjectiveState.inProgress:
				return 0;
			case commonEnums.learningObjectiveState.preliminaryProgress:
				return 1;
			case commonEnums.learningObjectiveState.notStarted:
				return 2;
			case commonEnums.learningObjectiveState.stuck:
				return 3;
			case commonEnums.learningObjectiveState.finished:
				return 4;
			default:
				return 5;
			}
		},

		nameWithCulture: function (data) {
			var sortingKey = pupilSortService.getSortField(classId);
			var check = ko.unwrap(data[sortingKey]) || '';

			if (_.isString(check)) {
				check = check.toLowerCase();
			}
			if (_.isBoolean(check)) {
				check = (check) ? 1 : 0;
			}

			return check;
		},

		settingsSortingKey: function () {
			return pupilSortService.getSortField(classId);
		}

	});

	SortableHelper.prototype.name = SortableHelper.prototype.default;

	return SortableHelper;
});
